// The merchant-page `transaction` and `redirection` events send the payment
// method key in `payment_method`. A missing, null or empty key yields
// `undefined`, which `postMessage` drops from the payload (no title fallback).
export const getTransactionPaymentMethodKey = (transaction) => {
  const key = transaction?.payment_method_key;
  return typeof key === 'string' && key.length > 0 ? key : undefined;
};
